import { View } from "react-native";
import { LinkButton, Modal } from "../../components";
import { PendingChangeRequest } from "../types";
import { Fragment } from "react";
import { Text } from "react-native-paper";
import { readableDate } from "../../utils/dateUtils";

const PendingChangeRequestsModal = ({
  visible,
  onDismiss,
  pendingChangeRequests,
  onContinue,
}: {
  visible: boolean;
  onDismiss(): void;
  pendingChangeRequests: PendingChangeRequest[];
  onContinue: (id: string) => void;
}) => {
  return (
    <Modal {...{ visible, onDismiss, title: "Pending Changes" }}>
      <View className="mb-8">
        {[...pendingChangeRequests]
          .sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())
          .map((pendingChangeRequest, index) => (
            <Fragment key={index}>
              <View
                className={`py-4 px-6 flex-col ${
                  index !== pendingChangeRequests.length - 1 ? "border-b border-sky-light" : null
                }`}
              >
                <View className="flex-row items-center justify-between">
                  <Text className="text-small-normal font-400 text-ink-light">{`Submitted: ${readableDate(
                    pendingChangeRequest.createdAt
                  )}`}</Text>
                  <LinkButton testID="cancel-change-request-button" onPress={() => onContinue(pendingChangeRequest.id)}>
                    Cancel
                  </LinkButton>
                </View>
                <View className="flex-col mt-1">
                  <Text className="text-regular-tight font-500 text-ink-darker">{pendingChangeRequest.facility?.name}</Text>
                  <Text className="text-small-tight font-400 text-ink-darker mt-1.5">
                    {["start_new_employment", "start_new_unlisted_employment"].includes(pendingChangeRequest.details?.type)
                      ? "Added employment"
                      : "Edited employment"}
                  </Text>
                </View>
              </View>
            </Fragment>
          ))}
      </View>
    </Modal>
  );
};

export default PendingChangeRequestsModal;
